/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Plan_Build_Dose_EditInputs */

const en_us2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edit the sets of ${i?.name}`)
};

const pt_br2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editar séries de ${i?.name}`)
};

const es_419_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editar las series de ${i?.name}`)
};

const pt_pt2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editar séries de ${i?.name}`)
};

const fr_fr2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifier les séries de ${i?.name}`)
};

const de_de2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sätze von ${i?.name} bearbeiten`)
};

const it_it2_plan_build_dose_edit = /** @type {(inputs: Plan_Build_Dose_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modifica le serie di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Edit the sets of {name}" |
*
* @param {Plan_Build_Dose_EditInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_edit = /** @type {((inputs: Plan_Build_Dose_EditInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_EditInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_edit(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_edit(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_edit(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_edit(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_edit(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_edit(inputs)
	return en_us2_plan_build_dose_edit(inputs)
});
export { plan_build_dose_edit as "plan-build.dose_edit" }